import {fetchHelp} from '../../../services/form/form';
import {mapHelpData} from '../utils/popover-utils';
import {patchColumnHelpContent} from '../utils/help';
import {helpMessage, Column} from '../../../stores/Form/Column';

export const getFieldHelp = async (Fname: string, column: Column) => {
    if (column.helpMessage) return column.helpMessage;
    const response = await fetchHelp(Fname, column.Name, {
        handleMessages: false
    });
    const helpData = mapHelpData(response.Messages[0]);
    const patchHelpData = {...helpData, content: patchColumnHelpContent(helpData?.content)};
    column.setHelpMessage(patchHelpData as helpMessage);
    return patchHelpData;
};

export const getFormHelpText = async (Fname: string) => {
    const res = await fetchHelp(Fname, undefined, {
        handleMessages: false
    });
    return mapHelpData(res.Messages[0]);
};
